"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _config = require("../../config");

var _TranslateAware = _interopRequireDefault(require("../../components/TranslateAware/TranslateAware"));

var _Version = require("../../components/Version");

var _LoginPage = require("../LoginPage");

var _Notifications = _interopRequireDefault(require("../../components/Notifications/Notifications"));

var _ModalWindow = require("../../components/ModalWindow");

var _router = require("../../router");

var _Full = require("../../components/Full");

var _ViewSwitch = require("../../components/ViewSwitch");

var _Utils = _interopRequireDefault(require("../../utils/Utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Error = (0, _TranslateAware["default"])(function (_ref) {
  var translate = _ref.translate,
      message = _ref.message;
  var okText = translate("app/error/ok");
  if (okText === "app/error/ok") okText = "OK";
  var messageText = translate(message);
  if (messageText === "app/error/common") messageText = "Something went wrong. Click OK to reload page.";
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("p", {
    className: "error-text"
  }, messageText), _react["default"].createElement("button", {
    onClick: function onClick() {
      window.location.reload();
    }
  }, okText));
});

var App =
/*#__PURE__*/
function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _getPrototypeOf(App).apply(this, arguments));
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var isTestEnvironment;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isTestEnvironment = this.props.isTestEnvironment;

                if (isTestEnvironment) {
                  document.title = "Staging | " + document.title;
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          locale = _this$props.locale,
          messagesLoadError = _this$props.messagesLoadError,
          newVersion = _this$props.newVersion,
          version = _this$props.version,
          isUpdateProcess = _this$props.isUpdateProcess,
          isAuthorized = _this$props.isAuthorized,
          isMessagesFetching = _this$props.isMessagesFetching,
          messages = _this$props.messages,
          loaderImg = _this$props.loaderImg;

      var localProvider = _Utils["default"].getLocaleConfig(locale).provider;

      var error = null;

      if (messagesLoadError) {
        error = "app/error/common";
      }

      var showLoaderView = error || !version || isUpdateProcess || messages.length === 0 && isMessagesFetching;

      if (showLoaderView || !isAuthorized) {
        document.body.classList.remove('main-screen');
      } else {
        document.body.classList.add('main-screen');
      }

      return _react["default"].createElement(_antd.LocaleProvider, {
        locale: localProvider
      }, _react["default"].createElement(_router.BrowserRouter, {
        onUpdate: function onUpdate() {
          return window.scrollTo(0, 0);
        }
      }, function () {
        if (showLoaderView) {
          return _react["default"].createElement("div", {
            className: "app-loader"
          }, _react["default"].createElement("div", {
            className: "app-loader-container"
          }, _react["default"].createElement("div", null, _react["default"].createElement("img", {
            className: "logo",
            src: _config.Config.get("settings", "logo"),
            alt: "Logo"
          }), isUpdateProcess && _react["default"].createElement("p", null, "Update to new version ", newVersion.version), error ? _react["default"].createElement(Error, {
            message: error
          }) : _react["default"].createElement("p", {
            className: "spinner"
          }, _react["default"].createElement("img", {
            src: loaderImg,
            alt: "loader"
          })), _react["default"].createElement("div", {
            className: "version",
            style: {
              textAlign: "center",
              fontSize: "11px",
              paddingTop: "20px"
            }
          }, _react["default"].createElement(_Version.Version, {
            withDetails: false
          })))));
        } else if (!isAuthorized) {
          return _react["default"].createElement(_LoginPage.LoginPage, null);
        } else {
          return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Notifications["default"], null), _react["default"].createElement("div", {
            className: "main-wrp"
          }, _react["default"].createElement(_Full.Full, null, _react["default"].createElement(_ViewSwitch.ViewSwitch, null))), _react["default"].createElement(_ModalWindow.ModalWindow, null));
        }
      }()));
    }
  }]);

  return App;
}(_react.Component);

exports.App = App;